import type { ExtractPropTypes, PropType } from "vue";
import type TenantEnterprise from "./tenant-enterprise.vue";

export const TenantEnterpriseProps = {
  label: {
    type: String,
    default: "当前单位",
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => [],
  },
  multiple: {
    type: Boolean,
    default: true,
  },
  popperClass: {
    type: String,
    default: "",
  },
  // 默认选中模式
  // default 默认选中当前单位
  // all-child 默认选中当前单位及子单位
  defaultMode: {
    type: String as PropType<"default" | "all-child">,
    default: "default",
  },
  /**
   * pinia window.microApp.getData()
   */
  action: Object,
  isOnDuty: {
    type: Boolean,
    default: false,
  },
  defaultEnterpriseId: {
    type: Number as PropType<number | string>,
    default: 0,
  },
};

export interface TenantEnterpriseItem {
  name: string;
  enterpriseId: number | string;
  tenantId: number | string;
}
export interface TenantEnterpriseChangeValueType {
  arr: TenantEnterpriseItem[];
  obj: TenantEnterpriseItem;
}

export const TenantEnterpriseEmits = {
  change: (value: TenantEnterpriseChangeValueType) => value,
};

export type TenantEnterprisePropsType = ExtractPropTypes<
  typeof TenantEnterpriseProps
>;
export type TenantEnterpriseInstance = InstanceType<typeof TenantEnterprise>;
